"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BnsErrorToJSON = exports.BnsErrorFromJSONTyped = exports.BnsErrorFromJSON = void 0;
const runtime_1 = require("../runtime");
function BnsErrorFromJSON(json) {
    return BnsErrorFromJSONTyped(json, false);
}
exports.BnsErrorFromJSON = BnsErrorFromJSON;
function BnsErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': !runtime_1.exists(json, 'error') ? undefined : json['error'],
    };
}
exports.BnsErrorFromJSONTyped = BnsErrorFromJSONTyped;
function BnsErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': value.error,
    };
}
exports.BnsErrorToJSON = BnsErrorToJSON;
//# sourceMappingURL=BnsError.js.map